import { useIntl } from 'react-intl';

import UFOSegment from '@atlaskit/react-ufo/segment';

import { GlobalNavProductRecommendationsSimple } from './global-nav-product-recommendations/components/global-nav-product-recommendations-simplified';
import { GlobalNavEyebrow } from './nav-links-container';
import {
	ProductGrid,
	ProductItem,
	useProductData,
	Product,
	ProductCategory,
} from './global-nav-products-dropdown';

export const GlobalNavFeaturedCollectionDropdown = ({ isMobile }: { isMobile?: boolean }) => {
	const intl = useIntl();
	const { productsByTag } = useProductData();

	return (
		<UFOSegment name="collections-container-with-rovo">
			<ProductGrid
				isRovoTitle={true}
				header={
					<>
						<GlobalNavProductRecommendationsSimple isMobile={isMobile} />
						<GlobalNavEyebrow removeMargin={true} className="collections-four">
							{intl.formatMessage({
								id: 'GlobalNav.collections.featured.atlassiancollections.title',
								defaultMessage: 'Atlassian Collections',
							})}
						</GlobalNavEyebrow>
					</>
				}
			>
				{productsByTag[ProductCategory.Featured].map((product: Product) => (
					<ProductItem key={product.id} {...product} currentCategory={ProductCategory.Featured} />
				))}
			</ProductGrid>
		</UFOSegment>
	);
};
